import React from "react"
import {Col, Row} from "react-bootstrap"
import BorderWrapper from "../../../components/dashboard/border-wrapper/BorderWrapper";
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import TargetBoxSkeleton from "./TargetBoxSkeleton";

export default function GoalsSkeleton() {

    return(
        <div className={'goals'}>
            <div className={'goals-heading'}>
                <div>
                    <BorderWrapper radius={8} margin={1} padding={1}>
                        <span className={'btn'}><HeadingSkeleton height={10} maxWidth={80} /></span>
                    </BorderWrapper>
                </div>
            </div>
            <div className="goals-section">
                <Row>
                    <Col md={6}>
                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="#00E6A9"
                            iconColor="#40C9A2"
                            Color="#E5FFF9"
                            backgroundColor="#BBBBBB05"
                        />
                    </Col>
                    <Col md={6}>
                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="#FF5C5C"
                            iconColor="#F95C59"
                            Color="#FFE5E5"
                            backgroundColor="#BBBBBB05"
                        />
                    </Col>
                    <Col md={6}>
                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="#00B2FF"
                            iconColor="#24B9C2"
                            Color="#E5F7FF"
                            backgroundColor="#BBBBBB05"
                        />
                    </Col>
                    <Col md={6}>
                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="#FFB800"
                            iconColor="#DCAB43"
                            Color="#FFF8E5"
                            backgroundColor="#BBBBBB05"
                        />
                    </Col>
                    <Col md={6}>
                        <TargetBoxSkeleton
                            GoalHeading="Quarterly Targets"
                            GoalEmptyHeading="Add Quaterly Targets"
                            boxColor="white"
                            iconColor="white"
                            Color="#F7E5FF"
                            backgroundColor="#BBBBBB05"
                        />
                    </Col>
                </Row>


            </div>
        </div>
    )
}